/* global Lenis */
/**
 * Inertia ("smooth") scrolling on desktop with a fine pointer, like Sky.
 * Horizon scrolls `.page-wrapper` from 990px up and the window below that, so Lenis is
 * attached to whichever element actually scrolls and rebuilt when that changes.
 */
(() => {
  if (typeof Lenis !== 'function' || window.Shopify?.designMode) return;

  const coarse = window.matchMedia('(pointer: coarse)');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  /** @type {any} */
  let lenis = null;
  /** @type {Element | Window | null} */
  let target = null;
  let frame = 0;

  function scroller() {
    const wrapper = document.querySelector('.page-wrapper');
    if (wrapper && /(auto|scroll)/.test(getComputedStyle(wrapper).overflowY)) return wrapper;
    return window;
  }

  function enabled() {
    return !coarse.matches && !reduced.matches && window.innerWidth >= 768;
  }

  function loop(/** @type {number} */ time) {
    lenis?.raf(time);
    frame = requestAnimationFrame(loop);
  }

  function destroy() {
    cancelAnimationFrame(frame);
    lenis?.destroy();
    lenis = null;
    target = null;
    window.skyLenis = null;
  }

  function create() {
    target = scroller();
    lenis = new Lenis({
      wrapper: target,
      duration: 2.2,
      easing: (/** @type {number} */ t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      naiveDimensions: true,
      allowNestedScroll: true,
      prevent: (/** @type {HTMLElement} */ node) =>
        node.matches('dialog, [role="dialog"], [aria-modal="true"], .sky-menu-drawer, sky-cart-drawer'),
    });
    window.skyLenis = lenis;
    syncLock();
    frame = requestAnimationFrame(loop);
  }

  function update() {
    if (!enabled()) {
      if (lenis) destroy();
      return;
    }
    if (lenis && target === scroller()) return;
    if (lenis) destroy();
    create();
  }

  /** Drawers lock the page with `html[scroll-lock]`; pause Lenis meanwhile. */
  function syncLock() {
    if (!lenis) return;
    if (document.documentElement.hasAttribute('scroll-lock')) lenis.stop();
    else lenis.start();
  }

  new MutationObserver(syncLock).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['scroll-lock'],
  });

  let resizeTimer = 0;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(update, 150);
  });
  coarse.addEventListener('change', update);
  reduced.addEventListener('change', update);

  update();
})();
